import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getTenantSlug } from '../api/client';

/**
 * Route guard for super admin routes
 * Requires authentication + isSuperAdmin flag
 */
const SuperAdminRoute: React.FC = () => {
  const { isAuthenticated, isLoading, isSuperAdmin } = useAuth();
  const hasTenantContext = !!getTenantSlug();

  // Show loading state while auth is initializing
  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  // Not authenticated - redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check for super admin access
  if (!isSuperAdmin) {
    // User is authenticated but not a super admin
    // On tenant subdomain, redirect to dashboard
    // On main domain, redirect to home
    if (hasTenantContext) {
      return <Navigate to="/dashboard" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default SuperAdminRoute;
